import styled from "styled-components";
import trophy from "assets/images/scene/trophy.svg";
import seatRows from "assets/images/scene/seat-rows-5.svg";
import spectators from "assets/images/scene/spectators.svg";
import sponsorSparnord from "assets/images/scene/sponsor-sparnord.png";
import sponsorNordicComputer from "assets/images/scene/sponsor-nordic-computer.png";

export const Tribune = () => {

    return (
        <>
            <Spectators />
            <Edge>
                <div>
                    <Trophy src={trophy} alt="Vinder pokal" />
                    <img src={sponsorNordicComputer} alt="Sponsor" />
                </div>
                <div>Skalborg &nbsp;&nbsp;&nbsp; Badminton</div>
                <div>
                    <img src={sponsorSparnord} alt="Sponsor" />
                </div>
            </Edge>
        </>
    )
}

const Spectators = styled.div`
    height: 250px;
    width: 100%;
    background: url(${spectators}) center 75px no-repeat, url(${seatRows}) center 0px no-repeat;
    position: absolute;
    bottom: 0;
`;

const Edge = styled.div`
    display: flex;
    align-items: center;
    height: 65px;
    width: 100%;
    color: #96928E;
    font-size: 30px;
    font-weight: 700;
    border-top: 10px solid #C6895B;
    background: linear-gradient(180deg, #575757 15.1%, #2C2C2C 100%);
    position: absolute;
    bottom: -1px;

    & > div{
        flex: 1;
    }
`;

const Trophy = styled.img`
    position: absolute;
    bottom: 70px;
    left: 70px;
`;